/*
 * OK BYE v76 : liste de souhaits.
 * - Cœurs [data-okbye-wl="handle"] sur les cartes et les fiches produit ; liste gardée dans le navigateur.
 * - Compteur dans l'en-tête [data-okbye-wl-count].
 * - Page /pages/ma-liste (section okbye-wishlist) : affiche la liste, ou une liste partagée (?l=handle1,handle2).
 */
(function () {
  var KEY = 'okbye-wishlist';
  var EN = (document.documentElement.lang || '').indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = EN ? {
    added: 'Added to your wishlist', removed: 'Removed from your wishlist', see: 'See my list'
  } : {
    added: 'Ajouté à ta liste de souhaits', removed: 'Retiré de ta liste', see: 'Voir ma liste'
  };

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) !== -1; }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-okbye-wl]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-okbye-wl')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });
    document.querySelectorAll('[data-okbye-wl-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-okbye-wl-head]').forEach(function (a) {
      a.classList.toggle('has-items', list.length > 0);
    });
  }

  var toastTimer;
  function toast(msg, withLink) {
    var el = document.getElementById('okbye-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'okbye-wl-toast';
      el.className = 'okbye-wl-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; el.appendChild(s);
    if (withLink) {
      var a = document.createElement('a'); a.href = ROOT.replace(/\/$/, '') + '/pages/ma-liste'; a.textContent = T.see + ' →'; el.appendChild(a);
    }
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 3200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-okbye-wl]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-okbye-wl');
    var list = read();
    var i = list.indexOf(h);
    if (i === -1) { list.unshift(h); write(list); toast(T.added, true); }
    else { list.splice(i, 1); write(list); toast(T.removed, false); }
    paint();
    document.dispatchEvent(new CustomEvent('okbye:wishlist-changed'));
  }, true);

  // Les cartes ajoutées plus tard (défilement infini, tiroir, recherche) reçoivent aussi le bon état
  var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(paint, 150); });
  function start() {
    paint();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  window.OkbyeWishlist = { read: read, write: write, has: has, paint: paint };
})();
